import { fromEvent, Subject } from "rxjs";
import { IAnalyticsService } from "../services/interfaces/analyticsService";
import { AccordionInteractionEvent } from "../models/analytics"
import { AnalyticsEventName } from "../enums/analyticsEventName"

// VM for managing a section in an Accordion. Handles open/close events, and enhances SR support
class AccordionSection {

    //analytics that needs to be triggered
    private analyticsService: IAnalyticsService;

    // dom elements
    private sectionEl: HTMLElement;
    private triggerEl: HTMLElement;
    private contentEl: HTMLElement;
    private initClosed: Boolean;

    // internal observables
    private isOpen$ = new Subject();

    // triggers on any state change. value is true when section is open, false if closed.
    public onStateChange = this.isOpen$.asObservable();

    constructor(sectionEl: HTMLElement, analyticsService: IAnalyticsService, initClosed: Boolean = true) {
        this.analyticsService = analyticsService;
        this.sectionEl = sectionEl;
        this.triggerEl = sectionEl.querySelector<HTMLElement>(".js-accordion-section-trigger");
        this.contentEl = sectionEl.querySelector<HTMLElement>(".js-accordion-section-content");
        this.initClosed = initClosed;
        if (this.triggerEl && this.contentEl) {
            this.init();
        }
    }

    private init() {

        fromEvent(this.triggerEl, 'click').subscribe(() => {
            const isExpanded = this.triggerEl.getAttribute("aria-expanded") === "true";
            const accordionLocation = this.sectionEl.dataset["accordionLocation"];
            let triggerLabel = this.sectionEl.querySelector<HTMLElement>(".accordion-component__section-trigger:not([data-gtmignore])")?.innerText ?? null;

            if (accordionLocation === "leftNav") {
                triggerLabel = this.triggerEl.parentElement.querySelector<HTMLElement>(".siteleftmenu__link")?.innerText ?? null;
            }

            if (triggerLabel) {
                const analyticsData = new AccordionInteractionEvent(
                    this.sectionEl.parentElement.dataset["id"],
                    this.sectionEl.parentElement.dataset["accordionTitle"],
                    triggerLabel,
                    parseInt(this.sectionEl.dataset["sectionindex"]),
                    isExpanded ? "accordion section hidden" : "accordion section shown", //clicking switches to new state
                    accordionLocation
                );

                this.analyticsService.RecordEvent(AnalyticsEventName.AccordionInteraction, analyticsData);
            }

            this.isOpen$.next(!isExpanded);
            // isExpanded ? this.triggerEl.focus() : this.contentEl.focus();
        });

        this.isOpen$.subscribe(isOpen => {
            if (isOpen) {
                this.sectionEl.classList.add("accordion-component__section--expanded");
                this.contentEl.removeAttribute("hidden");
                this.triggerEl.setAttribute("aria-expanded", "true");
            } else {
                this.sectionEl.classList.remove("accordion-component__section--expanded");
                this.contentEl.setAttribute("hidden", "");
                this.triggerEl.setAttribute("aria-expanded", "false");
            }
        });

        // close section on first load?
        this.initClosed ? this.close() : this.open();
    }

    public open() {
        this.isOpen$.next(true);
    }

    public close() {
        this.isOpen$.next(false);
    }
}

export { AccordionSection };
